// extracted by mini-css-extract-plugin
export default {"header":"UpdateLessonModal_header__vysug"};